module.exports = __webpack_public_path__ + "assets/img/crown.5f270a1c.png";